import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const CateringCards = () => {
  const [activeModal, setActiveModal] = useState(null);

  const openModal = (modalType) => {
    setActiveModal(modalType);
  };

  const closeModal = () => {
    setActiveModal(null);
  };

  const cardData = [
    {
      id: 'pickup',
      heading: 'PickUp Catering',
      subtitle: 'Perfect for office lunches, birthday dinners, or your backyard bash. Just order ahead and pick up your spread hot and ready.',
      menuButtons: [
        { label: 'BBQ Catering', modalType: 'bbq-packages' },
        { label: 'Deli Trays', modalType: 'family-meals' },
        { label: 'Sandwich Trays', modalType: 'sides-addons' }
      ],
      descriptionHeading: 'Ready to Go. Easy to Serve.',
      description: 'Disposable plates, utensils, and napkins are available if needed. Trays are ready for easy transport and quick setup.',
      buttonText: 'Request Pickup Quote',
      queryParam: 'pickup' 
    },
    {
      id: 'delivery',
      heading: 'Delivery Catering',
      subtitle: 'For any-sized event where you want the flavor without the heavy lifting. A Kinder\'s crew member delivers your BBQ hot and ready to enjoy.',
      menuButtons: [
        { label: 'BBQ Catering', modalType: 'bbq-packages' },
        { label: 'Deli Trays', modalType: 'family-meals' },
        { label: 'Sandwich Trays', modalType: 'sides-addons' }
      ],
      descriptionHeading: 'Ready to Go. Easy to Serve.',
      description: 'Disposable plates, utensils, and napkins are available if needed. Delivered in ready-to-eat and quick setup trays. Setup assistance is available.',
      buttonText: 'Request Delivery Quote',
      queryParam: 'delivery' 
    },
    {
      id: 'onsite',
      heading: 'On-Site Catering',
      subtitle: 'Whether it’s 50 guests or 10,000, Kinder’s brings the crew, the smokers, and the flavor. We fire it up fresh. You bring the appetite.',
      menuButtons: [
        { label: 'Most Requested', modalType: 'most-requested' },
        { label: 'Down Home', modalType: 'down-home' },
        { label: 'Wedding Special', modalType: 'wedding-special' },
        { label: 'Banquet Special', modalType: 'banquet-special' },
        { label: 'Half & Half Options', modalType: 'half-and-half' },
        { label: 'Custom Menu', modalType: 'custom-menu' },
        { label: 'Holiday Menu', modalType: 'holiday-menu' }
      ],
      descriptionHeading: 'Ready to Go. Easy to Serve.',
      description: 'Enjoy a full on-site BBQ experience with our pro pit crew smoking meats fresh at your event and our skilled team serving up buffet and station spreads.',
      buttonText: 'Request On-Site Quote',
      queryParam: 'onsite' 
    }
  ];

  return (
    <>
      {/* Cards Section */}
      <section className="section py-6">
        <div className="container">
          <div className="columns is-multiline is-variable is-6">
            {cardData.map((card) => (
              <div key={card.id} className="m-0 p-2 column is-4-desktop is-12-tablet">
                <div className="cardCatering has-equal-height">
                  <div className="card-content p-5">
                    {/* Card Header */}
                    <div className="mt-2 content">
                      <h2 className="m-0 p-0 subtitle is-align-center">
                        {card.heading}
                      </h2>
                      <p className="px-4 is-align-center">
                        {card.subtitle}
                      </p>
                    </div>

                    {/* Desktop Menu Options */}
                    <div className="">
                      <h3 className="mt-5 mb-3 subtitle is-align-center colorGreen is-6">
                        Menu Options
                      </h3>
                      
                      <div className="buttons is-flex is-flex-direction-m-0 py-0 px-2 column mb-4">
                        {card.menuButtons.map((button, index) => (
                          <button
                            key={index}
                            className="button is-outlined is-fullwidth mb-2"
                            onClick={() => openModal(button.modalType)}
                          >
                            {button.label}
                          </button>
                        ))}
                      </div>

                      <p className="mt-4 mx-4 mb-4 small is-align-left">
                        <span className='is-bold'>{card.descriptionHeading}</span> <br />{card.description}
                      </p>
                    </div>

                    {/* Mobile Menu Options */}
                    {/* <div className="is-hidden-mobile">
                      <div className="buttons is-flex is-flex-direction-m-0 py-0 px-2 column mb-4">
                        {card.menuButtons.map((button, index) => (
                          <button
                            key={index}
                            className="button is-outlined is-fullwidth mb-2"
                            onClick={() => openModal(button.modalType)}
                          >
                            {button.label}
                          </button>
                        ))}
                      </div>
                    </div> */}

                    {/* Quote Button - Updated with query parameter */}
                    <div className="mt-auto">
                      <Link to={`/catering/request-quote?type=${card.queryParam}`} className="">
                        <button className="button is-primary is-fullwidth has-text-weight-semibold">
                          {card.buttonText}
                        </button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Modal */}
      {activeModal && (
        <div className="modal is-active">
          <div className="modal-background" onClick={closeModal}></div>
          <div className="modal-card br-50 backgroundColorWhite">
              
            
              <div className="modal-card-body">
                <div className='is-flex is-flex-direction-row is-justify-content-end'>
                  <button
                  className="delete"
                  aria-label="close"
                  onClick={closeModal}
                ></button>
                </div>

                {/* <p className="modal-card-title">
                  {getModalTitle(activeModal)}
                </p> */}

                {getModalContent(activeModal)}
              </div>
           
          </div>
        </div>
      )}

      {/* Equal Height CSS */}
      <style>{`
        .has-equal-height {
          height: 100%;
          display: flex;
          flex-direction: column;
        }
        .has-equal-height .card-content {
          flex: 1;
          display: flex;
          flex-direction: column;
        }
        .has-equal-height .mt-auto {
          margin-top: auto;
        }
      `}</style>
    </>
  );
};

// Helper function to get modal content
const getModalContent = (modalType) => {
  // This is where you'll add your actual menu content
  // For now, returning placeholder content
  const content = {
    'bbq-packages': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>Pickup & Delivery Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Choose 1, 2, or 3 Meats and 2 side salads.</h2>
        <p className='px-6 mb-2 is-align-center'>All orders include BBQ beans, dinner rolls with butter, Kinder’s Mild BBQ Sauce, plates, plastic ware and napkins.</p>
        
        <p className='mt-4 is-bold'>Choice of Meats</p> 
        <p className='mb-1'>Marinated ball tip, pork loin (boneless), chicken quarters, St. Louis Style Pork Ribs, Marinated Tri-Tip, Hot or Mild Link</p>
        <p className='tiny'>* Ribs and tri-tip are additional costs.</p>

        <p className='mt-4 is-bold'>Choice of Salads</p>
        <p>Caesar, potato, macaroni, tossed green (includes three dressings), pasta, fresh fruit.</p>  

        <p className='mt-4 is-bold'>Choice of Beverages and Desserts</p>
        <p className='mb-1'>Assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 
      </div>
    ),
    'family-meals': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>Pickup & Delivery Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Deli Trays</h2>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-4 is-bold'></p> 
        <p>Our deli trays feature black forest ham, Italian dry salami, pastrami, roast beef, peppered turkey, roasted turkey, smoked turkey. Cheeses include American, cheddar, smoked cheddar, Monterey jack, pepper jack, provolone, Swiss.  Also available are assorted bread trays and condiment trays for your sandwich making needs.</p>
        
      </div>
    ),
    'sides-addons': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>Pickup & Delivery Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Sandwich Trays</h2>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-4 is-bold'></p> 
        <p className='mb-4'>Our sandwich trays feature any of our deli sandwiches or hot sandwiches to create an assortment for your catering needs.</p>
      </div>
    ),
    'most-requested': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Most Requested</h2>
        <p className='px-6 mb-2 is-align-center'>Savor our most-requested premium selections for a flawless BBQ experience.</p>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-4 is-bold'>Menu</p> 
        <p className='mb-1'>Marinated Ball Tip, Chicken Quarters, Tossed Green Salad with 3 Dressings, Ol' Fashioned Potato Salad, and BBQ Beans. Dinner rolls served with butter. Includes Kinder’s BBQ Sauce, paper plates, plastic ware and napkins.</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold small'>Notes</p>
        {/* <p>All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p>   */}
        <p>Skilled serving staff available upon request.</p>
      </div>
    ),
    'down-home': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Down Home</h2>
        <p className='px-6 mb-2 is-align-center'>Strengthen bonds and celebrate success with our hearty corporate BBQ catering.</p>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-4 is-bold'>Menu</p> 
        <p className='mb-1'>Pork Ribs (St. Louis Style), Chicken Quarters, Tossed Green Salad with 3 Dressings, Ol’ Fashioned Potato Salad, BBQ Beans. Includes dinner rolls with butter, Kinder’s BBQ Sauce, paper plates, plastic ware and napkins.</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold small'>Notes</p>
        {/* <p>All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p>   */}
        <p>Skilled serving staff available upon request.</p>
      </div>
    ),
    'wedding-special': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Wedding Special</h2>
        <p className='px-6 mb-2 is-align-center'>Toast love and create unforgettable memories with our elegant wedding catering.</p>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-4 is-bold'>Menu</p> 
        <p className='mb-1'>Marinated Ball Tip, Chicken Breast (Airline), Caesar Salad or Tossed Green Salad with 3 Dressings, Baked Potato or Roasted Red Potato, and Green Beans. Dinner rolls served with butter. Includes Kinder’s BBQ Sauce, paper plates, plastic ware and napkins.</p>
        <p className='tiny'>* Substitute Tri Tip, extra charge per person.</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold'>Notes</p>
        {/* <p>All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p>   */}
        <p>Skilled serving staff available upon request.</p>
      </div>
    ),
    'banquet-special': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Banquet Special</h2>
        <p className='px-6 mb-2 is-align-center'>Bring the festival spirit with our bold BBQ flavors and festival-ready sides.</p>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-4 is-bold'>Menu</p> 
        <p className='mb-1'>Prime Rib (Boneless), Caesar Salad or Tossed Green Salad with 3 Dressings, Baked Potato, and Green Beans. Dinner rolls served with butter. Includes Kinder’s BBQ Sauce, paper plates, plastic ware and napkins.</p>
        <p className='tiny'>* Add Chicken, extra charge per person.</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold small'>Notes</p>
        {/* <p>All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p>   */}
        <p>Skilled serving staff available upon request.</p>
      </div>
    ),
    'half-and-half': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Half & Half Options</h2>
        {/* <p className='px-6 mb-2 is-align-center'>Mix and match our signature dishes with custom half-and-half catering options.</p> */}
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-6 is-bold'>Half & Half Option 1 Menu</p> 
        <p className='mb-1'>½ BBQ Hamburgers, ½ Chicken Breast (Boneless), Tossed Green Salad with 3 Dressings, Ol’ Fashioned Potato Salad, BBQ Beans, Buns, Condiments.</p>

        <p className='mt-4 is-bold'>Half & Half Option 2 Menu</p> 
        <p className='mb-1'>½ BBQ Hamburgers, ½ Hot Dogs, and Potato Chips, Macaroni, Coleslaw, or Potato Salad, BBQ Beans, Buns, Condiments.</p>

        <p className='mt-4 is-bold'>Half & Half Option 3 Menu</p> 
        <p className='mb-1'>½ Rib Eye Steak, ½ Chicken Breast (Boneless), Tossed Green Salad with 3 Dressings, Ol’ Fashioned Potato Salad, BBQ Beans, Steak Rolls, Condiments.</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold small'>Notes</p>
        {/* <p>Includes dinner rolls serviced with butter, Kinder’s BBQ Sauce, paper plates, plastic ware and napkins. All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p> */}
        <p>Dinner rolls served with butter. Includes Kinder’s BBQ Sauce, paper plates, plastic ware and napkins. Skilled serving staff available upon request.</p>  
      </div>
    ),
    'custom-menu': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Custom Menu</h2>
        {/* <p className='px-6 mb-2 is-align-center'>Anything’s Possible with a Custom Menu Crafted Just for Your Crowd</p> */}
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-6 is-bold'>Looking for something different?</p> 
        <p className='mb-1'>Anything’s possible with a custom menu crafted just for your crowd. Whether you’re hosting a backyard bash, corporate lunch, wedding, or something in between, our catering team will work with you to build the perfect menu. From specialty entrees to vegetarian swaps to regional favorites, nothing’s off the table. If you can dream it, we can dish it.</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold small'>Notes</p>
        {/* <p>Includes dinner rolls serviced with butter, Kinder’s BBQ Sauce, paper plates, plastic ware and napkins. All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p> */}
        <p>Dinner rolls served with butter. Includes Kinder’s BBQ Sauce, paper plates, plastic ware and napkins. Skilled serving staff available upon request.</p>  
      </div>
    ),
    'holiday-menu': (
      <div className='m-4'>
        <h1 className='mt-3 mb-4 catering is-align-center colorBlack'>On-Site Menu</h1>
        <h2 className="mb-1 cateringHead is-align-center colorGreen">Holiday Menu Options</h2>
        <p className='px-6 mb-2 is-align-center is-bold'>Available November 1 – December 31.</p>
        <p className='px-6 mb-2 is-align-center'></p>
        
        <p className='mt-6 is-bold'>Holiday Option 1 Menu</p> 
        <p className='mb-1'>Holiday Menu Option 1 Turkey (Boneless Breasts), Ham (Boneless), Mashed Potatoes and Gravy, Stuffing, Green Beans, Cranberry Sauce, and Tossed Salad with 3 Dressings. Dinner rolls served with butter. Includes Kinder’s BBQ Sauce, paper plates, plastic ware and napkins.</p>

        <p className='mt-4 is-bold'>Holiday Option 2 Menu</p> 
        <p className='mb-1'>Includes the same items as the Option 1 Menu without the Ham (Boneless).</p>

        <p className='mt-4 is-bold'>Optional</p>
        <p className='mb-1'>Fresh fruit salad, assorted cookies, brownies, assorted sodas, bottled water.</p>
        <p className='tiny'>* Beverages and desserts are additional cost.</p> 

        <p className='mt-4 is-bold small'>Notes</p>
        {/* <p>Includes dinner rolls serviced with butter, Kinder’s BBQ Sauce, paper plates, plastic ware and napkins. All On-Site caterings are self-serve buffet lines (unless stated otherwise). Skilled staff serving buffet and stations upon request.</p> */}
        <p>Skilled serving staff available upon request.</p>  
      </div>
    )
  };
  
  return content[modalType] || <p>Menu content not available.</p>;
};

export default CateringCards;